<template lang="pug">
div
  el-row.padding
    el-col.margin-bottom-container(:md="8" :sm="24")
      div.coluna-externa
        div.coluna-interna
          div.quadrante-1
            img.custom-img(src="~@/assets/icons/Cadastro.png")
            h1.custom-title Edital de Credenciamento
            h2.segundo-titulo {{tipoEdital}}
          div.padding-top-cadastro
            el-row.align-itens
              span.custom-title-span N° Edital:
              span.custom-padding-span {{edital}}
            el-row.align-itens
              span.custom-title-span Data da abertura:
              span.custom-padding-span {{abertura}}
            el-row.align-itens
              span.custom-title-span Data encerramento:
              span.custom-padding-span {{encerramento}}
            el-row.align-itens
              span.custom-title-span Situação:
              span.custom-padding-span {{situacao}}
            el-row.align-itens
              span.custom-span(@click='download') Baixar Edital
            el-row.custom-padding
              el-button.btn.btn-primary(:disabled='situacao !== "Aberto"' type='primary' @click.native='navigateRoute') Cadastrar
</template>

<script>
export default {
  name: 'CardEdital',
  methods: {
    downloadEdital () {
      console.log('Botão Clicado')
    }
  },
  props: {
    edital: {
      type: String,
      required: false
    },
    abertura: {
      type: String,
      required: false
    },
    encerramento: {
      type: String,
      required: false
    },
    situacao: {
      type: String,
      required: false
    },
    tipoEdital: {
      type: String,
      required: false
    },
    navigateRoute: {
      type: Function,
      required: false
    },
    download: {
      type: Function,
      required: false
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.custom-padding {
  padding: 20px;
}

.custom-padding-span {
  padding-left: 5px;
}

.custom-title-span {
  font-weight: bold;
}

.coluna-externa {
  color: #777373;
  width: 350px;
  padding: 20px;
  background: white 0% 0% no-repeat padding-box;
  margin: 0 auto;
  border-radius: 14px;
  opacity: 3;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.coluna-interna {
  text-align: center;
  border: 2px dashed $color-primary;
  border-radius: 14px;
}

.align-itens {
  text-align: left;
  color: $title-color;
}

.quadrante-1 {
  text-align: center;
  width: 100%;
  height: 25%;
  border-bottom: 1.8px dashed $color-primary;
}

.custom-img {
  width: 5.5em;
  padding-top: 30px;
}

.custom-title {
  font-size: 20px;
  color: black;
}

.custom-span {
  font-weight: bold;
  cursor: pointer;
}

.custom-span:hover{
  color: $card-dashboard-green;
}

.padding-top-cadastro {
  padding-top: 20px;
  padding-left: 22px;
  padding-right: 22px;
  line-height: 1.45em;
}

@media (max-width: 1256px) {
  .coluna-externa {
    width: 250px;
  }
}

</style>
